import React, { ReactElement } from 'react';

import { useForm } from 'react-hook-form';
import { Button, LbInput } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import { GridTableRow } from '../../../../shared/components/table-components';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { FoodType } from '../../../constants/foodType';
import { FoodsFilterData } from '../../../interfaces/FoodsFilters';
import { useFoodsListStore } from '../hooks/useFoodsListStore';
import { FOODS_TABLE_COLUMN, FoodsTableColumn } from '../NgzFoods.settings';

type FilterRowProps = {
  visibleColumns: FoodsTableColumn[];
  foodType: FoodType;
};

const FilterRow = observer(({ visibleColumns, foodType }: FilterRowProps) => {
  const {
    filterMethods: { applyFilters, filterData, defaultFilterData },
  } = useFoodsListStore(foodType);

  const { control, handleSubmit, watch, reset } = useForm<FoodsFilterData>({
    defaultValues: filterData,
  });

  useAutoSubmitForm(handleSubmit(applyFilters), watch, ['name', 'brand']);

  const handleReset = () => {
    reset({ ...defaultFilterData });
  };

  const inputGeneralProps = { control, variant: 'outlined', size: 'small' } as const;

  const renderColumnsInfo: Record<FoodsTableColumn, ReactElement> = {
    [FOODS_TABLE_COLUMN.NAME]: (
      <LbInput
        {...inputGeneralProps}
        name="name"
        placeholder="Name"
        dataTestId="name-input"
      />
    ),
    [FOODS_TABLE_COLUMN.BRAND]: (
      <LbInput
        {...inputGeneralProps}
        name="brand"
        placeholder="Brand"
        dataTestId="brand-input"
      />
    ),
    [FOODS_TABLE_COLUMN.QTY]: <div />,
    [FOODS_TABLE_COLUMN.MEASUREMENT]: <div />,
    [FOODS_TABLE_COLUMN.PROTEIN]: <div />,
    [FOODS_TABLE_COLUMN.CARB]: <div />,
    [FOODS_TABLE_COLUMN.FATS]: <div />,
    [FOODS_TABLE_COLUMN.RECOMMENDATIONS]: <div />,
    [FOODS_TABLE_COLUMN.TAG]: <div />,
    [FOODS_TABLE_COLUMN.ACTIONS]: (
      <Button
        variant="outlined"
        size="small"
        type="reset"
        fullWidth
        onClick={handleReset}
      >
        Clear All
      </Button>
    ),
  };

  return (
    <GridTableRow
      variant="filter"
      component="form"
      onSubmit={(event) => event.preventDefault()}
    >
      {visibleColumns.map((column) => (
        <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { FilterRow };
